// extracted by mini-css-extract-plugin
export default {"h1":"EditProfile_h1__6-uLR","input":"EditProfile_input__aeBUV","button":"EditProfile_button__C+WUe","form":"EditProfile_form__1koFE"};